export default class UtilitarioGeral {
  static valorValido(valor: any):boolean {
    if (valor === undefined || valor === null || valor === '') {
      return false;
    }
    return true;
  }

  static validaValorComLimiteCaracteres(valor: any, limiteCaracteres: number):boolean {
    if (!this.valorValido(valor)) {
      return false;
    }
    if (valor.length === limiteCaracteres) {
      return true;
    }
    return false;
  }

  static objetoValido(objeto: any):boolean {
    if (objeto === undefined || objeto === null || objeto === '') {
      return false;
    }

    if (objeto) {
      return true;
    }

    return false;
  }

  static validaBoleano(valor: any):boolean {
    if (valor === undefined || valor === null) {
      return false;
    }

    return true;
  }

  static validaCodigo(valor: any):boolean {
    if (valor === undefined || valor === null) {
      return false;
    }

    if (valor > 0) { return true; }

    return false;
  }

  /**
 * Cria instância local para o objeto com os mesmos valores
 * porém removendo as referências e impactos visuais na tela
 */
  static instanciaObjetoLocal(objeto: any):any {
    return JSON.parse(JSON.stringify(objeto));
  }

  static validaLista(valor: any):boolean {
    if (valor === undefined || valor === null) {
      return false;
    }

    if (valor.length > 0) {
      return true;
    }
    return false;
  }

  static converterValorNumericoJson(valor: any):number {
    if (this.valorValido(valor)) {
      const valorConvertido = valor.replace('.', '').replace(',', '.');
      return valorConvertido;
    }
    return 0;
  }

  static montaExibicaoEmpresa(codigoExibicao: string, nomeExibicao: string):string {
    let exibicaoEmpresa = '';
    if (this.valorValido(codigoExibicao)) {
      exibicaoEmpresa += `${codigoExibicao} - `;
    }
    exibicaoEmpresa += nomeExibicao;
    return exibicaoEmpresa;
  }

  static primeiraLetraMaiuscula(texto: string):string {
    if (this.valorValido(texto)) {
      if (texto.length > 1) {
        return texto && texto[0].toUpperCase() + texto.slice(1).toLowerCase();
      }
      return texto.toUpperCase();
    }
    return '';
  }

  static converterCodigoParaString(codigo: number): string {
    if (!this.validaCodigo(codigo)) {
      return '';
    }

    const texto = codigo.toString();

    const mapa: { [key: string]: string } = {
      0: 'o',
      1: 'a',
      2: 'b',
      3: 'c',
      4: 'd',
      5: 'e',
      6: 'f',
      7: 'g',
      8: 'h',
      9: 'i',
    };

    let resultado = '';

    for (let i = 0; i < texto.length; i += 1) {
      const c = texto[i];

      if (mapa[c]) {
        resultado += mapa[c];
      } else {
        resultado += c;
      }
    }

    return resultado;
  }

  static obterCodigoDaString(texto: string): number {
    if (!this.valorValido(texto)) {
      return 0;
    }

    const mapa: { [key: string]: string } = {
      o: '0',
      a: '1',
      b: '2',
      c: '3',
      d: '4',
      e: '5',
      f: '6',
      g: '7',
      h: '8',
      i: '9',
    };

    let resultado = '';

    for (let i = 0; i < texto.length; i += 1) {
      const c = texto[i].toLowerCase();

      if (mapa[c]) {
        resultado += mapa[c];
      } else {
        resultado += texto[i];
      }
    }

    return Number(resultado);
  }

  static documentoIdentificacaoCPFouCNPJ(cpfOuCnpj: string):string {
    let texto = '';
    if (cpfOuCnpj === undefined || cpfOuCnpj === null || cpfOuCnpj === '') {
      return '';
    }

    if (cpfOuCnpj.length === 11) {
      texto = 'CPF';
    } if (cpfOuCnpj.length === 14) {
      texto = 'CNPJ';
    }

    return texto;
  }

  static obterApenasNumeros(valor: string):string {
    const valorNovo = valor.replace(/[^0-9]/g, '');
    return valorNovo;
  }

  static gerarTokenUnico(tamanho = 30):string {
    let token = '';
    const caracteres = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const quantidadeCaracteres = caracteres.length;
    for (let i = 0; i < tamanho; i += 1) {
      token += caracteres.charAt(Math.floor(Math.random() * quantidadeCaracteres));
    }
    return token;
  }

  static downloadArquivo(linkUrl: string): void {
    // Cria um elemento <a> temporário para realizar o download
    const link = document.createElement('a');
    link.href = linkUrl;
    link.target = '_blank';
    link.download = this.obterNomeArquivo(linkUrl); // Opcional: Define um nome de arquivo
    document.body.appendChild(link); // Adiciona o link ao corpo do documento para ser clicável
    link.click(); // Simula um clique no link para iniciar o download
    document.body.removeChild(link); // Remove o link do corpo do documento após o download
  }

  static obterNomeArquivo(url: string): string {
    // Obter o nome do arquivo a partir do URL
    return url.split('/').pop() || 'arquivo';
  }
}
